import {
    Button,
    CircularProgress,
    IconButton,
    Tooltip
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';

import muiStyles from './styles';
import { ToolbarButtonProps } from './types';

export default function ToolbarButton(props: ToolbarButtonProps) {
    const {
        className,
        id,
        iconClassName,
        Icon,
        iconColor,
        text,
        onClick,
        active,
        disabled,
        actionInProgress
    } = props;

    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    if (Icon) {
        // Tooltip creates an error when putting around a disabled input, so adding the below if condition
        if (disabled || actionInProgress) {
            return (
                <IconButton
                    className={`${classes.root} ${classes.icon} ${className} ${active && classes.active}`}
                    disabled
                    id={id}
                    onClick={onClick}
                >
                    {actionInProgress ?
                        <CircularProgress
                            className={classes.actionInProgressIcon}
                            size={16}
                        />
                        : (
                            <Icon
                                className={iconClassName}
                                iconColor={iconColor ||
                                    theme?.app?.applicationColors.enumColors.grey ||
                                    '#888888'}
                            />
                        )}
                </IconButton>
            );
        }

        return (
            <Tooltip
                classes={{ popper: classes.tooltip }}
                disableInteractive
                title={text || ''}
            >
                <IconButton
                    className={`${classes.root} ${classes.icon} ${className} ${active && classes.active}`}
                    disabled={disabled}
                    id={id}
                    onClick={onClick}
                >
                    <Icon
                        className={iconClassName}
                        iconColor={iconColor ||
                            theme?.app?.applicationColors.enumColors.grey ||
                            '#888888'}
                    />
                </IconButton>
            </Tooltip>
        );
    }

    return (
        <Button
            className={`${classes.root} ${className} ${active && classes.active}`}
            disabled={disabled || actionInProgress}
            id={id}
            onClick={onClick}
        >
            {actionInProgress ?
                <CircularProgress
                    className={classes.actionInProgressIcon}
                    size={16}
                />
                : text}
        </Button>
    );
}